export default color =>
  ({
    // Primary colors
    primary: '#635bff',
    primaryDark: '#5469d4',
    primaryLight: '#7a73ff',

    // Navy tones
    navy: '#0a2540',
    navyLight: '#425466',
    navyMedium: '#1a1f36',

    // Accent colors
    cyan: '#00d4ff',
    teal: '#11efe3',
    tealLight: '#e0fef9',
    green: '#33c27f',
    pink: '#ff80b5',

    // Neutral colors
    white: '#ffffff',
    offWhite: '#f6f9fc',
    lightGrey: '#f0f3f7',
    grey: '#e3e8ee',
    greyMedium: '#c1c9d2',
    greyDark: '#8898aa',
    slate: '#697386',

    // Text colors
    textPrimary: '#0a2540',
    textSecondary: '#425466',
    textMuted: '#697386',
    textLight: '#8898aa',

    // Semantic colors
    success: '#33c27f',
    warning: '#ffbb33',
    error: '#ff5b5b',
    info: '#635bff',

    // Legacy mappings for backwards compatibility (deprecated - use primary names above)
    skyBlue: '#00d4ff', // use: cyan
    blue: '#5469d4', // use: primaryDark
    offBlack: '#0a2540', // use: navy
    black: '#0a2540', // use: navy
    openBlue: '#635bff', // use: primary
    'open-blue': '#635bff', // use: primary
    paleGrey: '#8898aa', // use: greyDark
    lighterGrey: '#f6f9fc', // use: offWhite
    lighterCyan: '#f6f9fc', // use: offWhite
    lightCyan: '#e3e8ee', // use: grey
    indigo: '#635bff', // use: primary
    red: '#ff5b5b', // use: error
    orange: '#ffbb33', // use: warning
    lightTeal: '#11efe3', // use: teal
    lightSky: '#f6f9fc', // use: offWhite
    purple: '#635bff', // use: primary
    mainBlue: '#635bff' // use: primary
  }[color])
